import React from "react";
import tw from "twin.macro";
import { useSelector } from "react-redux";

import Sidebar from "../Components/Sidebar";
import Content from "../Components/Content";
import SignIn from "../Components/SignIn";
import OldSignin from "../Components/OldSignin";

const AppContainer = tw.div`relative bg-gray-200`;
const BodyContainer = tw.div`flex relative w-full`;

export default () => {
  const number = useSelector((state) => state.AppComponent.value);

  return (
    <>
      {number === 1 ? (
        <div>
          <SignIn />

          {/* <OldSignin/> */}
        </div>
      ) : (
        <AppContainer>
          <BodyContainer className="AppBodyContainer">
            <Sidebar />
            <Content />
          </BodyContainer>
        </AppContainer>
      )}
    </>
  );
};
